import { Box, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useStyles } from './style'
// import badRequestImageDesktop from '../../assets/logo/bad-request-error-image-desktop.png'
import badRequestImageMobile from '../../assets/logo/bad-request-error-image-mobile.png'
import badRequest from '../../assets/logo/bad-request.png'

export default function ErrorPage() {
  const classes = useStyles()
  const location = useLocation()
  const [statusCode, setStatusCode] = useState()

  useEffect(() => {
    const code = location.state ? Number(location.state.code) : 0
    if (code !== 200) {
      setStatusCode(true)
    } else {
      setStatusCode(false)
    }
  }, [location])

  return (
    <>
      {statusCode && (
        <>
          <span className={classes.container}>
            <Box className={classes.pictureContainer}>
              <picture>
                <source className={classes.img} media="(min-width: 770px)" srcSet={badRequest} />
                <img className={classes.img} src={badRequestImageMobile} alt="" />
              </picture>
            </Box>
            <Box className={classes.titleContainer}>
              <Box className={classes.titleContent}>
                <Typography variant="h5" className={classes.title}>
                  Ops, encontramos um erro
                </Typography>
                <Typography variant="h4" className={classes.text}>
                  Estamos trabalhando para solucionar o problema.
                  <br />
                  Por favor, tente novamente mais tarde.
                </Typography>
              </Box>
            </Box>
          </span>
        </>
      )}
    </>
  )
}
